import type { ReactNode } from "react";
import classNames from "classnames";

export function QuoteCardBadge({
  icon,
  children,
  "data-testid": dataTestId,
  className,
}: {
  icon?: ReactNode;
  children: ReactNode;
  "data-testid"?: string;
  className?: string;
}) {
  const quoteCardBadgeClasses = classNames(
    "mobius-quote-card__badge",
    className,
  );

  return (
    <div className={quoteCardBadgeClasses} data-testid={dataTestId}>
      {icon && <span className="mobius-quote-card__badge-icon">{icon}</span>}
      {children}
    </div>
  );
}
